import mixpanel, { Dict } from 'mixpanel-browser';

export enum EventAction {
    LANDED = 'Landing',
    QUERIED_HEALTH_PLAN = 'Health Plan Queried',
    HEALTH_PLAN_SELECTED = 'Health Plan Selected',
    TYPE_SELECTED = 'Type Selected',
    SERVICE_SELECTED = 'Service Selected',
    QUERIED_MEDICAL_GROUP = 'Medical Group Queried',
    MEDICAL_GROUP_SELECTED = 'Medical Group Selected',
    QUERIED_PCP = 'PCP Queried',
    PCP_SELECTED = 'PCP Selected',
    NETWORK_STATUS = 'Network Status',
    NOT_SURE_SELECTED = 'Not Sure Selected',
    SCHEDULE_APPOINTMENT = 'Schedule Appointment',
}

export const initMixpanelAnalytics = () => {
    if (process.env.REACT_APP_MIXPANNEL_ENABLED !== 'true') return;
    if (!process.env.REACT_APP_MIXPANNEL_TOKEN) {
        console.error('No MixPanel project token provided.');
        return;
    }
    mixpanel.init(process.env.REACT_APP_MIXPANNEL_TOKEN,
        {
            debug: false,
            track_pageview: true,
            persistence: 'localStorage',
        }
    );
    mixpanel.register({
        platform: 'web',
        environment: process.env.REACT_APP_MIXPANNEL_ENV,
    });
};

/**
 * Capture an event with the Mixpanel library. I made this its own
 * method so I can log in development, conditionally check if it's
 * enabled, or other custom behavior.
 */
export const trackMixpanelEvent = (name: EventAction, properties?: Dict | undefined): void => {
    if (process.env.REACT_APP_MIXPANNEL_ENABLED !== 'true') return;
    try {
        mixpanel.track(name, properties);
    } catch (e) {
        console.error('Mixpanel tracking error:', e);
    }
};
